import * as fetcher from "../fetcher";
import { stringifyOpportunitySearchQuery } from "./search";
import {
  type OpportunitiesSearchFilters,
  type OpportunitiesSearchOptions,
} from "./types";

interface GenerateFollowUpProjectsResponse {
  requestId: number;
  status: "PROCESSING";
  projectsCount: number;
  message: string;
}

export const generateFollowUpProjects = async (
  followUpAssignee: string,
  projectsCount: number,
  filters: OpportunitiesSearchFilters,
  options: OpportunitiesSearchOptions
): Promise<GenerateFollowUpProjectsResponse> => {
  const query = stringifyOpportunitySearchQuery(filters, options);
  const res = await fetcher.opportunity.post<
    GenerateFollowUpProjectsResponse,
    false
  >(`/brief/followup/generate?${query}`, {
    followUpAssignee,
    projectsCount,
  });
  return res;
};

export const generateProjectSummary = (projectId: number) =>
  fetcher.opportunity.post<null, true>(
    `/${projectId}/ai/summary/generate`,
    {},
    undefined,
    true
  );
